export default __webpack_public_path__ + "static/media/crear-saml.ea32a7e3.pdf";